/**
 * Stable per-browser device id for mentor / audit headers (X-Device-Id).
 */
export function getDeviceId(): string {
  let id = localStorage.getItem('deviceId');
  if (!id) {
    const random =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2);
    id = `dev_${Date.now()}_${random}`;
    localStorage.setItem('deviceId', id);
  }
  return id;
}
